import { render, staticRenderFns } from "./DraggableList.vue?vue&type=template&id=3b2b50f1&scoped=true&"
import script from "./DraggableList.vue?vue&type=script&lang=ts&"
export * from "./DraggableList.vue?vue&type=script&lang=ts&"
import style0 from "./DraggableList.vue?vue&type=style&index=0&id=3b2b50f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2b50f1",
  null
  
)

export default component.exports